module.exports = __webpack_public_path__ + "aab2aabcb3fe4066045652a43cbd3f78.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio4/08_4MCA-Deine-Raumkapsel.ogg
// module id = 795
// module chunks = 0